import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { ServiceItem } from "src/app/model/model";
import { ServiceItemService } from "src/app/services/service-item.service";


const PROB_DOMAIN = {
  text:
  {
    "fill-mask": "Completar-Máscara",
    "question-answering": "Pregunta-Respuesta",
    summary: "Resumen",
    "table-question-answering": "Pregunta-Respuesta-Tabla",
    "text-classification": "Clasificación-Texto",
    "text-generation": "Generación-Texto",
    "text2text-generation": "Generación-Texto-Texto",
    "token-classification": "Clasificación-Token",
    translation: "Traducción",
    "zero-shot-classification": "Clasificación-Zero-Shot"
  }
};

@Component({
  selector: "app-service-detail-view",
  templateUrl: "./service_detail_view.component.html",
})
export class ServiceDetailViewComponent implements OnInit {
  demoDetailInst = "summary";
  demoDomain = "text";

  constructor(private route: ActivatedRoute, private serviceItemService: ServiceItemService, protected $gaService: GoogleAnalyticsService) {
    this.serviceInstance = "bert-base-uncased";
    this.typeText = PROB_DOMAIN[this.demoDomain][this.demoDetailInst];
  }

  @Input()
  serviceInstance: string;

  typeTag = "";
  typeText: string;

  description = ``

  serviceId = -1;
  idField = "id";
  serviceDetails: ServiceItem | undefined;

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.serviceId = parseInt(params[this.idField], 10);
      this.serviceDetails = this.serviceItemService.getById(this.serviceId);
    });
    this.$gaService.pageView("/service/" + this.serviceId.toString(), "Visit the service: " + this.serviceDetails.name);
  }

  getSVGName() {
    return this.demoDetailInst;
  }
}
